import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useGetProjectSurveyTimesetList } from '../../interfaces/survey';
import theme from '../../styles/theme';
import { convertToDayList } from './commonUtil';
import { DesktopTimePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { CommonModalWrap } from '../../styles/common';
import CommonModalBar from '../common/CommonModalBar';

const MainWrap = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const DetailWindow = styled.div`
    position: relative;
    background: ${theme.color.white[100]};
    width: 70%;
    height: 70vh;
    border-radius: 18px;
    padding: 1rem 1rem;
`;

const SurveyTimeList =  styled.ul`
    list-style-type: none;
    width: 100%;
    max-height: 100%;
    padding: 0;
    margin: 0;
    cursor: pointer;
    li {
        display: grid;
        grid-template-columns: 0.2rem 8rem 16rem auto 0.2rem;
        gap: 1rem;
        font-size: 1rem;
        line-height: 3rem;
        height: 3rem;
    }
    .title {
        border-bottom: 2px solid ${theme.color.black[40]};
    }
    .st_list {
        border-bottom: 1px solid ${theme.color.black[20]};
    }
    .twoLine {
        white-space: break;
        font-size: 0.8rem !important;
        line-height: 0.8rem;
        margin: auto 0;
    }
    .st_list:last-child{
        border:0;
    }
`

const SurveyTimesetInfo = ({survey, handleRowClick, handleCloseClick}) => {

    const [timeList, setTimeList] = useState([]);

    const {data: surveyTimeList, refetch: surveyTimeListRefetch} = useGetProjectSurveyTimesetList(survey && survey.sid);

    useEffect(()=>{
        surveyTimeListRefetch();
    },[survey])

    useEffect(()=>{
        const temp = convertToDayList(surveyTimeList);
        setTimeList(temp);
    },[surveyTimeList])

    return (
        <CommonModalWrap style={{zIndex:1300}}>
            <DetailWindow>
                <CommonModalBar title={'조사시간 목록'} close={handleCloseClick}/>
                <MainWrap>
                    <SurveyTimeList>
                        <li className='title'>
                            <span/>
                            <span>조사일</span>
                            <span>시간</span>
                            <span>비고</span>
                            <span/>
                        </li>
                        { (timeList && timeList.length > 0) && timeList.map((item,index)=>
                            <ListItem key={index} item={item} onClick={(item)=>{handleRowClick(item);handleCloseClick()}}/>
                        )}
                    </SurveyTimeList>
                </MainWrap>
            </DetailWindow>
        </CommonModalWrap>
    )
}

const ListItem = ({item, onClick}) => {

    const [minTime, setMinTime] = useState();
    const [maxTime, setMaxTime] = useState();

    useEffect(()=>{
        if(item){
            const stime = item.timeList.map((tItem)=>tItem.stime).sort()[0];
            const etime = item.timeList.map((tItem)=>tItem.etime).reverse()[0];
            setMinTime(stime)
            setMaxTime(etime)
        }
    },[item])

    return (
        <li className='st_list' onClick={()=>onClick({sdate:item.sdate, stime:minTime, etime: maxTime})}>
            <span/>
            <span>{item.sdate}</span>
            <div style={{display:'flex',alignItems:'center'}}>
                {minTime}
                <span>~</span>
                {maxTime}
            </div>
            <span className='twoLine'>
                {item.timeList.map((tItem,tIndex)=>((tItem.text)+((item.timeList.length -1) !== tIndex ? ', ':'')  ))}
            </span>
            <span/>
        </li>
    )
}

export default SurveyTimesetInfo;